import { connect } from 'react-redux';
import { MenuItemLink, getResources } from 'react-admin';
import { withRouter, Link } from 'react-router-dom';
import AdminIcon from '@material-ui/icons/BugReport';
import Collapse from '@material-ui/core/Collapse';
import compose from 'recompose/compose';
import CustomerIcon from '@material-ui/icons/Wc';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PresalesIcon from '@material-ui/icons/Description';
import React, { Component, createElement } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

class Menu extends Component {
    state = {
        admin: false,
        presales: false,
        customer: false,
    }

    renderCollapseMenu = (type, title, icon, resource) => {
        return (
            <div>
                <ListItem
                    style={{ paddingLeft: 16, paddingRight: 16, width: '99%', backgroundColor: '#f0f0f0' }}
                    button
                    onClick={() => this.setState({ [type]: !this.state[type] })}>
                    <ListItemIcon>
                        {icon}
                    </ListItemIcon>
                    <ListItemText inset primary={title} style={{ paddingLeft: 0, whiteSpace: 'nowrap' }} />
                    {this.state[type] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={this.state[type]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {
                            resource
                                .map(r => <NavList
                                    icon={r.icon}
                                    key={r.name}
                                    link={`/${r.name}`}
                                    primaryText={r.options.label || `${r.name.charAt(0).toUpperCase() + r.name.substr(1)}`}
                                    submenu />)
                        }
                    </List>
                </Collapse>
            </div>
        )
    }

    render() {
        const { resources, onMenuClick, logout } = this.props
        return (
            <div>
                {this.renderCollapseMenu('admin', 'Admin', <AdminIcon />, resources.filter(r => r.hasList && r.options.type === 'admin'))}
                {this.renderCollapseMenu('presales', 'Pre-Sales', <PresalesIcon />, resources.filter(r => r.hasList && r.options.type === 'presales'))}
                {this.renderCollapseMenu('customer', 'Customer', <CustomerIcon />, resources.filter(r => r.hasList && r.options.type === 'customer'))}
            </div>
        );
    }
}

const NavList = ({ onClick, link, primaryText, submenu, icon }) => (
    <MenuItemLink
        to={link}
        primaryText={primaryText}
        leftIcon={icon ? createElement(icon) : <CustomerIcon />}
        onClick={onClick} />
)

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
});


const mapStateToProps = state => ({
    resources: getResources(state),
});

export default compose(
    withRouter,
    connect(mapStateToProps),
    withStyles(styles))
    (Menu)


// WEBPACK FOOTER //
// ./src/components/Menu.js